import { useCallback, useState } from "react"

export function useSearchParams() {
  const [searchParams, setSearchParams] = useState(new URLSearchParams(""))

  const handleToggleSearchParams = useCallback((key: string, value: string | null) => {
    if (value === "" || !value) {
      setSearchParams((currSearchParams) => {
        currSearchParams.delete(key)
        const newSP = new URLSearchParams("")
        for (const [key, value] of currSearchParams) {
          newSP.set(key, value)
        }
        return newSP
      })
      return
    }

    setSearchParams((currSearchParams) => {
      currSearchParams.set(key, value)
      const newSP = new URLSearchParams("")
      for (const [key, value] of currSearchParams) {
        newSP.set(key, value)
      }

      return newSP
    })
  }, [])

  const handleRemoveSearchParams = useCallback((key: string) => {
    setSearchParams((currSearchParams) => {
      currSearchParams.delete(key)
      const newSP = new URLSearchParams("")
      for (const [key, value] of currSearchParams) {
        newSP.set(key, value)
      }
      return newSP
    })
  }, [])

  return {
    searchParams,
    handleToggleSearchParams,
    handleRemoveSearchParams,
  }
}
